import React from "react";
import AdminNotificationsComponent from "../../components/AdminNotifications/AdminNotifications.component";
import IPage from "../../interfaces/page";

const AdminNotificationsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <AdminNotificationsComponent></AdminNotificationsComponent>;
};

export default AdminNotificationsPage;
